import React, { Component } from 'react';
import axios from '../../axios-signup';
import { Redirect } from 'react-router-dom';
import Error from '../../components/UI/Error';
import wrapper from "../../hoc/wrapper";
import Header from "../../components/Header/Header";
import {Loader} from 'react-overlay-loader'

class CustomerInfo extends Component {
    state = {
        emailAddress: this.props.location.state.emailAddress,
        firstName: '',
        lastName: '',
        company: '',
        phoneNumber: '',
        errorMsg: '',
        submitted: false,
        unauthorized: false,
        loading: false,
        fromAws: false,
    };

    changeEvent = (event, input) => {
        this.setState({[input]: event.target.value})
    };

    onSubmit = (event) => {
        event.preventDefault();
        this.setState({loading: true});
        axios.post("/customer-info", {
            emailAddress: this.state.emailAddress,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            company: this.state.company,
            phoneNumber: this.state.phoneNumber
        }).then(res => {
            this.setState({submitted: true, loading: false, fromAws: res.data.fromAws})
        }).catch(err => {
            if (err.response.status === 401) {
                this.setState({unauthorized: true, loading: false})
            } else {
                this.setState({errorMsg: err.response.data.error, loading: false});
            }
        })
    };

    handleKeyPress = (event) => {
        if(event.key === 'Enter'){
            this.setState({loading: true});
            axios.post("/customer-info", {
                emailAddress: this.state.emailAddress,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                company: this.state.company,
                phoneNumber: this.state.phoneNumber
            }).then(res => {
                this.setState({submitted: true, loading: false, fromAws: res.data.fromAws})
            }).catch(err => {
                if (err.response.status === 401) {
                    this.setState({unauthorized: true, loading: false})
                } else {
                    this.setState({errorMsg: err.response.data.error, loading: false});
                }
            })
        }
    };

    render() {
        let redirect = null;

        if (this.state.submitted) {
            if (this.state.fromAws) {
                redirect = <Redirect to={{pathname: "/signup/aws-account", state: {emailAddress: this.state.emailAddress, fromAws: this.state.fromAws}}}/>
            } else {
                redirect =
                    <Redirect to={{pathname: '/signup/billing', state: {emailAddress: this.state.emailAddress}}}/>
            }
        } else if (this.state.unauthorized) {
            redirect = <Redirect to="/signup/"/>
        }

        return (
            <div>
                <Header currentWizard="4"/>
            <main role="main">
                <Loader fullPage={true} loading={this.state.loading}/>
                <section className="section yellow">
                    {redirect}
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-8 col-center text-center">
                                <h1 className="black"><strong>Customer Information</strong></h1>
                                <h5 className="gray mb-4"><strong>Please enter your customer information below.</strong>
                                </h5>
                                <Error errorMsg={this.state.errorMsg} divClass="col-md-9 col-center"/>
                                <div className="row">
                                    <div className="col-md-9 col-center">
                                        <div className="form-group">
                                            <input type="text" placeholder="First Name" className="form-control" onChange={(event) => this.changeEvent(event, 'firstName')} onKeyPress={e => this.handleKeyPress(e)}/>
                                        </div>
                                        <div className="form-group">
                                            <input type="text" placeholder="Last Name" className="form-control" onChange={(event) => this.changeEvent(event, 'lastName')} onKeyPress={e => this.handleKeyPress(e)}/>
                                        </div>
                                        <div className="form-group">
                                            <input type="text" placeholder="company" className="form-control" onChange={(event) => this.changeEvent(event, 'company')} onKeyPress={e => this.handleKeyPress(e)}/>
                                        </div>
                                        <div className="form-group">
                                            <input type="text" placeholder="phone" className="form-control" onChange={(event) => this.changeEvent(event, 'phoneNumber')} onKeyPress={e => this.handleKeyPress(e)}/>
                                        </div>
                                        <div className="form-group mt-4">
                                            <input type="submit" value="Submit" className="btn btn-primary" onClick={this.onSubmit}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            </div>
        )
    }
}

export default wrapper(CustomerInfo);